module.exports = __webpack_public_path__ + "img/icon-preorder.2434c07.svg";